export const ADMIN_ALL_ORDERS_REQUEST = "ADMIN_ALL_ORDERS_REQUEST";
export const ADMIN_ALL_ORDERS_SUCCESS = "ADMIN_ALL_ORDERS_SUCCESS";
export const ADMIN_ALL_ORDERS_FAIL = "ADMIN_ALL_ORDERS_FAIL";
